(function () {
  'use strict';

  const SELECTOR = 'form[data-form-validate], form[id^="ContactSubscribe-"], form[id^="ContactForm-"]';
  const FIELD_SELECTOR = 'input, textarea, select';
  const SKIP_TYPES = ['submit', 'button', 'reset', 'hidden', 'file'];

  const DEFAULT_MESSAGES = {
    valueMissing: 'This field is required.',
    valueMissingCheckbox: 'Please check this box to continue.',
    valueMissingRadio: 'Please select an option.',
    valueMissingSelect: 'Please select an option.',
    typeMismatchEmail: 'Please enter a valid email address.',
    typeMismatchUrl: 'Please enter a valid URL.',
    tooShort: 'Please enter at least {min} characters.',
    tooLong: 'Please enter no more than {max} characters.',
    patternMismatch: 'Please match the requested format.',
    patternMismatchTel: 'Please enter a valid phone number.',
  };

  const ERROR_CLASS = 'form-message form-message--small form-message--error';
  const ICON_SVG =
    '<svg class="icon icon-error icon--small" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<circle cx="8" cy="8" r="7.25" stroke="currentColor" stroke-width="1.5"/>' +
      '<path d="M8 4.5v4M8 11.25v.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  function errorIdFor(field) {
    if (field.dataset.errorTarget) return field.dataset.errorTarget;
    if (field.id) return field.id + '-error';
    return null;
  }

  function getErrorEl(field) {
    const id = errorIdFor(field);
    if (id) {
      const existing = document.getElementById(id);
      if (existing) return existing;
    }
    const wrapper = field.closest('.form-field') || field.parentElement;
    if (!wrapper) return null;
    const el = document.createElement('span');
    el.className = ERROR_CLASS;
    if (id) el.id = id;
    el.hidden = true;
    wrapper.appendChild(el);
    return el;
  }

  function messageFor(field) {
    const validity = field.validity;
    const ds = field.dataset;
    if (validity.customError) return field.validationMessage;

    if (validity.valueMissing) {
      if (ds.errorRequired) return ds.errorRequired;
      if (field.type === 'checkbox') return DEFAULT_MESSAGES.valueMissingCheckbox;
      if (field.type === 'radio') return DEFAULT_MESSAGES.valueMissingRadio;
      if (field.tagName === 'SELECT') return DEFAULT_MESSAGES.valueMissingSelect;
      return DEFAULT_MESSAGES.valueMissing;
    }
    if (validity.typeMismatch) {
      if (field.type === 'email') return ds.errorEmail || DEFAULT_MESSAGES.typeMismatchEmail;
      if (field.type === 'url') return DEFAULT_MESSAGES.typeMismatchUrl;
    }
    if (validity.patternMismatch) {
      if (field.type === 'tel') return ds.errorPattern || DEFAULT_MESSAGES.patternMismatchTel;
      return ds.errorPattern || DEFAULT_MESSAGES.patternMismatch;
    }
    if (validity.tooShort) {
      return (ds.errorMinlength || DEFAULT_MESSAGES.tooShort).replace('{min}', String(field.minLength));
    }
    if (validity.tooLong) {
      return (ds.errorMaxlength || DEFAULT_MESSAGES.tooLong).replace('{max}', String(field.maxLength));
    }
    return field.validationMessage || DEFAULT_MESSAGES.valueMissing;
  }

  function showError(field, message) {
    field.setAttribute('aria-invalid', 'true');
    const errorEl = getErrorEl(field);
    if (!errorEl) return;
    errorEl.innerHTML = ICON_SVG + ' ' + escapeHtml(message);
    errorEl.hidden = false;
    if (errorEl.id) field.setAttribute('aria-describedby', errorEl.id);
  }

  function clearError(field) {
    field.removeAttribute('aria-invalid');
    const id = errorIdFor(field);
    if (!id) return;
    const errorEl = document.getElementById(id);
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function shouldSkip(field) {
    if (field.disabled) return true;
    if (SKIP_TYPES.indexOf(field.type) !== -1) return true;
    if (field.dataset.noValidate === 'true') return true;
    return false;
  }

  function validateField(field) {
    if (shouldSkip(field)) return true;
    if (field.checkValidity()) {
      clearError(field);
      return true;
    }
    showError(field, messageFor(field));
    return false;
  }

  function validateForm(form) {
    const fields = form.querySelectorAll(FIELD_SELECTOR);
    let firstInvalid = null;
    for (let i = 0; i < fields.length; i++) {
      const valid = validateField(fields[i]);
      if (!valid && !firstInvalid) firstInvalid = fields[i];
    }
    return firstInvalid;
  }

  function attach(form) {
    if (form.dataset.validationAttached === 'true') return;
    form.dataset.validationAttached = 'true';
    form.setAttribute('novalidate', 'novalidate');

    form.addEventListener('blur', function (e) {
      const target = e.target;
      if (!target.matches || !target.matches(FIELD_SELECTOR)) return;
      validateField(target);
    }, true);

    form.addEventListener('input', function (e) {
      const target = e.target;
      if (!target.matches || !target.matches(FIELD_SELECTOR)) return;
      if (target.getAttribute('aria-invalid') === 'true') validateField(target);
    });

    form.addEventListener('submit', function (e) {
      const firstInvalid = validateForm(form);
      if (firstInvalid) {
        e.preventDefault();
        e.stopPropagation();
        try { firstInvalid.focus({ preventScroll: false }); } catch (err) { firstInvalid.focus(); }
      }
    });
  }

  function init(root) {
    const scope = root || document;
    const forms = scope.querySelectorAll(SELECTOR);
    for (let i = 0; i < forms.length; i++) attach(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.FoxTheme = window.FoxTheme || {};
  window.FoxTheme.formValidation = { init: init, validate: validateForm };
})();
